import { render, staticRenderFns } from "./FieldScored.vue?vue&type=template&id=043ad604&scoped=true&"
import script from "./FieldScored.vue?vue&type=script&lang=js&"
export * from "./FieldScored.vue?vue&type=script&lang=js&"
import style0 from "./FieldScored.vue?vue&type=style&index=0&id=043ad604&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "043ad604",
  null
  
)

component.options.__file = "FieldScored.vue"
export default component.exports